import PageHero from "@/components/feature/PageHero";
import LaunchOfferSection from "@/components/feature/LaunchOfferSection";
import CtaSection from "@/components/feature/CtaSection";
import Accordion from "@/components/base/Accordion";
import Reveal from "@/components/base/Reveal";
import { homeFaqPreview } from "@/mocks/public";

export default function PricingPage() {
  return (
    <div className="flex flex-col">
      <PageHero
        eyebrow="Tarifs"
        current="Tarifs"
        title="6 mois gratuits, accès complet à toutes les fonctionnalités"
        description="Pendant notre offre de lancement, les propriétaires et les agences profitent de la plateforme sans frais et sans limites de formule."
      />

      <section className="py-14 md:py-20 bg-background-50">
        <div className="container-page">
          <LaunchOfferSection />
          <p className="mt-6 text-center text-xs text-foreground-500">
            * Offre de lancement réservée aux nouveaux comptes Propriétaire et Agence.
          </p>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-50">
        <div className="container-page">
          <Reveal>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-center text-foreground-950">
              Questions sur les tarifs
            </h2>
          </Reveal>
          <div className="mx-auto mt-10 max-w-3xl">
            <Accordion items={homeFaqPreview} />
          </div>
        </div>
      </section>

      <CtaSection
        title="Créez votre espace et profitez de 6 mois offerts."
        description="Inscrivez-vous en quelques minutes et accédez immédiatement à l'ensemble des modules, sans limites et sans paiement."
        primaryLabel="Créer mon compte gratuitement"
        primaryTo="/inscription"
      />
    </div>
  );
}